// Libs
import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Stack } from '@mui/material';
import { memo } from 'react';
// Components, Layouts, Pages
// Others
import { ColumnTypeKanban, IBaseKanban } from '~/utils/interface/common';
// Styles, images, icons

type ItemsType<T extends IBaseKanban> = {
  id: UniqueIdentifier;
  data: any;
  columnData?: ColumnTypeKanban<T>;
  render?: (data: T, columnData?: ColumnTypeKanban<T>) => React.ReactNode;
  disabled?: boolean;
};

function ItemsKanban<T extends IBaseKanban>(props: ItemsType<T>) {
  //#region Destructuring Props
  const { id, data, columnData, disabled, render } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: id,
    data: {
      type: 'item',
    },
    disabled: !!disabled,
  });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack
      id='itemsKanbanComponent'
      ref={setNodeRef}
      {...attributes}
      style={{
        transition,
        transform: CSS.Translate.toString(transform),
        opacity: isDragging ? 0.5 : 1,
        userSelect: 'none',
        width: '100%',
      }}
      {...listeners}
    >
      {render ? render(data, columnData) : data.name}
    </Stack>
  );
}

export default memo(ItemsKanban) as typeof ItemsKanban;
